import request from '@/utils/request'

export const getBookingStatistics = () =>
  request({
    url: '/statistics/bookings',
    method: 'get'
  })
